package com.ervasstudio.tracoemovimento.pages.blog

import androidx.compose.runtime.*
import com.ervasstudio.tracoemovimento.model.Foto
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*



@Composable
fun GaleriaFotosComClique(fotos: List<Foto>, isMobile: Boolean) {
    val tamanhoLote = if (isMobile) 2 else 3   // era 3 sempre
    var paginaAtual by remember { mutableStateOf(0) }
    var fotoSelecionada by remember { mutableStateOf<Foto?>(null) }

    val indiceInicial = paginaAtual * tamanhoLote
    val fotosVisiveis = fotos.drop(indiceInicial).take(tamanhoLote)

    val temAnterior = paginaAtual > 0
    val temProximo = indiceInicial + tamanhoLote < fotos.size

    Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {

        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {

            // --- BOTÃO ESQUERDA (ANTERIOR) ---
            Box(
                modifier = Modifier
                    .size(if (isMobile) 28.px else 40.px)         // era 40.px
                    .minWidth(if (isMobile) 28.px else 40.px)
                    .borderRadius(50.percent)
                    .flexShrink(0)
                    .backgroundColor(if (temAnterior) Color.black else Color.lightgray)
                    .cursor(if (temAnterior) Cursor.Pointer else Cursor.NotAllowed)
                    .opacity(if (temAnterior) 1.0 else 0.4)
                    .onClick { if (temAnterior) paginaAtual-- },
                contentAlignment = Alignment.Center
            ) {
                SpanText(
                    text = "❮",
                    modifier = Modifier.color(Color.white).fontWeight(FontWeight.Bold)
                        .fontSize(if (isMobile) 14.px else 16.px)
                )
            }

            // --- CONTEÚDO CENTRAL (A GRADE) ---
            Box(modifier = Modifier.weight(1f).margin(leftRight = if (isMobile) 0.5.cssRem else 1.cssRem)) {
                SimpleGrid(
                    numColumns = if (isMobile) numColumns(base = 2) else numColumns(base = 1, sm = 2, md = 3),   // era base=1 no mobile
                    modifier = Modifier.fillMaxWidth().gap(if (isMobile) 0.6.cssRem else 1.5.cssRem)
                ) {
                    fotosVisiveis.forEach { foto ->
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .aspectRatio(16, 9)
                                .borderRadius(if (isMobile) 10.px else 16.px)
                                .overflow(Overflow.Hidden)
                                .cursor(Cursor.Pointer)
                                .onClick { fotoSelecionada = foto }
                        ) {
                            Image(
                                src = foto.url,
                                modifier = Modifier.fillMaxSize().objectFit(ObjectFit.Cover)
                            )
                        }
                    }
                }
            }

            // --- BOTÃO DIREITA (PRÓXIMO) ---
            Box(
                modifier = Modifier
                    .size(if (isMobile) 28.px else 40.px)
                    .minWidth(if (isMobile) 28.px else 40.px)
                    .flexShrink(0)
                    .borderRadius(50.percent)
                    .backgroundColor(if (temProximo) Color.black else Color.lightgray)
                    .cursor(if (temProximo) Cursor.Pointer else Cursor.NotAllowed)
                    .opacity(if (temProximo) 1.0 else 0.4)
                    .onClick { if (temProximo) paginaAtual++ },
                contentAlignment = Alignment.Center
            ) {
                SpanText(
                    text = "❯",
                    modifier = Modifier.color(Color.white).fontWeight(FontWeight.Bold)
                        .fontSize(if (isMobile) 14.px else 16.px)
                )
            }
        }

        // --- LIGHTBOX (MODAL DE VISUALIZAÇÃO) ---
        fotoSelecionada?.let { foto ->
            Box(
                modifier = Modifier
                    .position(Position.Fixed)
                    .top(0.px).left(0.px).right(0.px).bottom(0.px)
                    .backgroundColor(rgba(0, 0, 0, 0.85))
                    .zIndex(9999)
                    .onClick { fotoSelecionada = null },
                contentAlignment = Alignment.Center
            ) {
                Image(
                    src = foto.url,
                    modifier = Modifier
                        .maxWidth(90.vw)
                        .maxHeight(85.vh)
                        .borderRadius(8.px)
                        .onClick { it.stopPropagation() }
                )

                Box(
                    modifier = Modifier
                        .position(Position.Absolute)
                        .top(20.px).right(20.px)
                        .cursor(Cursor.Pointer)
                        .onClick { fotoSelecionada = null }
                ) {
                    SpanText("✕", modifier = Modifier.color(Colors.White).fontSize(24.px))
                }
            }
        }
    }
}